var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',[_vm._v("─── @瀚乐思提供技术支持 ───")])}
var staticRenderFns = []

export { render, staticRenderFns }